import { filterGroupDropdownTemplate, filterCheckboxTemplate } from "../templates";

import { FilterDropdownTerm } from "./filter-dropdown-term";

import { FilterCheckboxTerm } from "./filter-checkbox-term";

var FilterBarDropdown = Backbone.View.extend({
    tagName: 'div',
    className: 'btn-group',
    events: {
        'click .toggle-open' : 'toggleDropdown'
    },
    initialize: function(){
        _.bindAll( this, 'render', 'addTerm', 'toggleDropdown', 'shutDropdown' );
        this.render();
    },

    /*
    Render the view markup
    */
    render: function(){
        var details = this.model.toJSON();
        var terms = this.model.get( 'terms' );
        window.debugLogger( terms );
        if ( this.model.get( 'type' ) == 'checkbox' ) {
            var checkboxHtml = filterCheckboxTemplate( details );
            this.el.innerHTML = checkboxHtml;
            terms.each( this.addTerm );
        } else {
            var dropdownHtml = filterGroupDropdownTemplate( details );
            this.el.innerHTML = dropdownHtml;
            terms.each( this.addTerm );
        }
        // this.listenTo( terms, 'change', this.updateTerms );
    },
    /*
    Toggle the dropdown open when clicked .toggle-open class
    */
    toggleDropdown: function( e ){
        e.preventDefault();
        // this.$el.toggleClass( 'open' );
    },
    /*
    Close the dropdown when a selection is made
    */
    updateTerms: function (){
        this.shutDropdown();
    },
    /*
    Shut the dropdown when selected
    */
    shutDropdown: function( ){
        //this.$el.removeClass( 'open' );
    },
    /*
    Add the individaul terms to the UI, conditionally checkbox or dropdwon
    */
    addTerm: function( term ){
        if ( this.model.get( 'type' ) == 'checkbox' ) {
            if ( term.get('name') ) {
                var checkboxItem = new FilterCheckboxTerm({ model: term });
                this.$(".boxes").append( checkboxItem.el );
            }
        } else {
            var dropdownItem = new FilterDropdownTerm({ model: term });
            this.$(".dropdown-menu").append( dropdownItem.el );
        }
    }
});

export {FilterBarDropdown};